import WrapperFormulaNode from "./WrapperFormulaNode.js";

/**
 * `negatedFormulaNode` is a concrete implementation of `wrapperFormulaNode`
 * representing a negated node.
 */
export default class NegatedFormulaNode extends WrapperFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitNegatedNode(this, additionalInformation);
	}

	static getType() {
		return "NegatedNode";
	}

	static precedence() {
		return 4;
	}
}
